import React, { useState, useEffect } from 'react';
import { getAllQuests, resetAllQuests, getQuestStatus, resetSpecificQuest } from '../utils/questReset';
import styles from './DevAdminPage.module.css';

const DevAdminPage: React.FC = () => {
  const [questStatus, setQuestStatus] = useState<Record<string, any>>({});
  const [resetLog, setResetLog] = useState<string[]>([]);

  useEffect(() => {
    refreshQuestStatus();
  }, []);

  const refreshQuestStatus = () => {
    const status = getQuestStatus();
    console.log('Quest status:', status);
    console.log('All quests:', getAllQuests());
    setQuestStatus(status);
  };

  const handleResetAllQuests = () => {
    const resetKeys = resetAllQuests();
    setResetLog([...resetLog, `Reset all quests. Removed ${resetKeys.length} keys: ${resetKeys.join(', ')}`]);
    refreshQuestStatus();
  };

  const handleResetSpecificQuest = (questId: string) => {
    const wasReset = resetSpecificQuest(questId);
    if (wasReset) {
      setResetLog([...resetLog, `Reset quest: ${questId}`]);
    } else {
      setResetLog([...resetLog, `Quest ${questId} was not started (nothing to reset)`]);
    }
    refreshQuestStatus();
  };

  const clearLog = () => {
    setResetLog([]);
  };

  return (
    <div className={styles.devAdminPage}>
      <h1>Developer Admin - Quest Management</h1>

      <div className={styles.warning}>
        ⚠️ This page is for development purposes only. Quest data is stored in localStorage and is browser-specific.
      </div>

      <div style={{ background: 'yellow', padding: '10px', margin: '10px 0' }}>
        <strong>DEBUG: DevAdminPage loaded successfully!</strong>
        <br />
        Available quests: {getAllQuests().length}
        <br />
        Quest status entries: {Object.keys(questStatus).length}
      </div>

      <div className={styles.section}>
        <h2>Quest Status</h2>
        <button
          onClick={refreshQuestStatus}
          style={{
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            marginBottom: '20px'
          }}
        >
          Refresh Status
        </button>

        <div className={styles.questGrid}>
          {getAllQuests().map(questId => {
            const status = questStatus[questId];
            const isCompleted = status && status.timeRemaining === 0 && !status.isStarted;
            const isStarted = status && status.isStarted;

            return (
              <div key={questId} className={styles.questCard}>
                <div className={styles.questHeader}>
                  <h3>{questId}</h3>
                  <div className={`${styles.statusBadge} ${
                    isCompleted ? styles.completed :
                    isStarted ? styles.started :
                    styles.notStarted
                  }`}>
                    {isCompleted ? 'Completed' : isStarted ? 'Started' : 'Not Started'}
                  </div>
                </div>

                {status && (
                  <div className={styles.questDetails}>
                    <small>
                      Started: {status.isStarted ? 'Yes' : 'No'}<br/>
                      Time Remaining: {status.timeRemaining}
                    </small>
                  </div>
                )}

                <button
                  onClick={() => handleResetSpecificQuest(questId)}
                  style={{
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    marginTop: '8px'
                  }}
                >
                  Reset Quest
                </button>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.section}>
        <h2>Bulk Actions</h2>
        <button
          onClick={handleResetAllQuests}
          style={{
            background: '#dc2626',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          Reset ALL Quests
        </button>
      </div>

      <div className={styles.section}>
        <h2>Reset Log</h2>
        <div className={styles.logHeader}>
          <button onClick={clearLog} className={styles.refreshButton}>Clear Log</button>
        </div>
        <div className={styles.logContainer}>
          {resetLog.length === 0 ? (
            <p className={styles.emptyLog}>No reset actions performed yet.</p>
          ) : (
            resetLog.map((entry, index) => (
              <div key={index} className={styles.logEntry}>
                <span className={styles.logTimestamp}>
                  {new Date().toLocaleTimeString()}
                </span>
                {entry}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default DevAdminPage;